import type { RetailFeatures } from '@retail/gatekeeper';
import { getEnv } from '@luna/env';
import type { RetailEnvironmentConfig } from '@retail/core-config';

import { featuresAT } from './AT';
import { featuresCZ } from './CZ';
import { featuresSK } from './SK';
import { featuresRO } from './RO';
import { featuresHR } from './HR';
import { featuresHU } from './HU';
import { featuresRS } from './RS';

const countryFeaturesMap = {
    AT: featuresAT,
    CZ: featuresCZ,
    'CZ-UAT': featuresCZ,
    SK: featuresSK,
    RO: featuresRO,
    HR: featuresHR,
    HU: featuresHU,
    RS: featuresRS,
};

const throwUnsupportedCountryError = (country: string): void => {
    throw new Error(`Country '${country}' not supported in getFeatures`);
};

export const getCountryFeatures = (): RetailFeatures => {
    const { country } = getEnv<RetailEnvironmentConfig>();
    // @ts-expect-error no-implicit-any
    return countryFeaturesMap[country] ?? throwUnsupportedCountryError(country);
};
